import { defineMessages } from 'react-intl';

export default defineMessages({
  thirtyDaysAverage: `30 D.`,
  thirtyDaysAverageFull: `The 30 days average`,
});
